import { CSSProperties } from 'react'
import dayjs from 'dayjs'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { EmojiMap } from 'components/ContentStrategyTypeEmoji/ContentStrategyTypeEmoji'
import { ContentStrategyTypeLabel } from '../../constants'
import { ContentStrategyType } from 'types'
import Styles from './CampaignRow.module.scss'

export interface CampaignRowSchedule {
  title?: string | null
  cover_image?: string | null
  start_date: string
  end_date: string
  content_strategy_type?: ContentStrategyType | null
}

interface CampaignRowProps {
  schedule: CampaignRowSchedule
  isChecked?: boolean
  className?: string
}

const dateRangeLabel = (schedule: CampaignRowSchedule) => {
  const start = dayjs(schedule.start_date)
  const end = dayjs(schedule.end_date)
  const sameMonth = start.isSame(end, 'month')
  return `${start.format('MMM D')} – ${end.format(sameMonth ? 'D' : 'MMM D')}`
}

export const CampaignRow = ({ schedule, isChecked = false, className }: CampaignRowProps) => {
  const contentType = schedule.content_strategy_type
  const emoji = contentType ? EmojiMap[contentType] : null
  const label = contentType ? ContentStrategyTypeLabel[contentType] : null
  const coverStyle: CSSProperties = schedule.cover_image ? { backgroundImage: `url(${schedule.cover_image})` } : {}

  return (
    <div className={cx(Styles.row, className)}>
      <div className={cx(Styles.cover, { [Styles.coverEmpty]: !schedule.cover_image })} style={coverStyle} />
      <div className={Styles.text}>
        <Text lineClamp={1} fontWeight={isChecked ? '500' : '400'}>
          {schedule.title || 'Untitled Campaign'}
        </Text>
        <Text variant="secondary" lineClamp={1}>
          {label && (
            <>
              <span>
                {emoji} {label}
              </span>
              <span className={Styles.subtitleDot} />
            </>
          )}
          <span>{dateRangeLabel(schedule)}</span>
        </Text>
      </div>
    </div>
  )
}

export const OneOffCampaignRow = ({ className }: { className?: string } = {}) => (
  <div className={cx(Styles.row, className)}>
    <div className={cx(Styles.cover, Styles.coverEmpty)} />
    <div className={Styles.text}>
      <Text>One-off content</Text>
      <Text variant="secondary">Post not assigned to a campaign</Text>
    </div>
  </div>
)
